import constants from '../../constants/app-constants';

const initialState = {
  requests: null
};

const CodeBlock = (state = initialState , action) => {
  switch(action.type){
  case constants.admin.CODE_BLOCK_NEW : return {...state , requests : action.payload};

  case constants.admin.CODE_BLOCK_GET: {
    return {...state, codeBlock: action.payload};
  }

  case constants.admin.CODE_BLOCK_EDIT: {
    return {...state, codeBlockEdit: action.payload};
  }

  default: return state;
  }
};

export default CodeBlock;